import app from './app'
import merchant from './merchant'

export default {
  app,
  merchant,
}
